import AboutProjects from './AboutProjects';

export default AboutProjects;
